import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";

interface ArticleImageCarouselProps {
  images: string[];
  itemsToShow?: number; // Optional prop to control items visible on desktop
}

const ArticleImageCarousel = ({ images, itemsToShow = 3 }: ArticleImageCarouselProps) => {
  if (!images || images.length === 0) return null;

  // Determine basis class based on itemsToShow for desktop
  let basisClass = "lg:basis-1/3"; // Default to 3 items
  if (itemsToShow === 1) {
    basisClass = "lg:basis-full";
  } else if (itemsToShow === 2) {
    basisClass = "lg:basis-1/2";
  } else if (itemsToShow === 4) {
    basisClass = "lg:basis-1/4";
  }
  // Add more conditions if other numbers of items are needed

  return (
    <Carousel
      opts={{
        align: "start",
        loop: images.length > itemsToShow, // Only loop if there are more images than shown at once
      }}
      className="w-full max-w-none py-8" // Added more vertical padding
    >
      <CarouselContent className="-ml-4">
        {images.map((src, index) => (
          <CarouselItem key={index} className={`pl-4 md:basis-1/2 ${basisClass}`}>
            <div className="aspect-square bg-muted rounded-lg overflow-hidden shadow-lg"> {/* Added rounded-lg and shadow-lg */}
              <img src={src} alt={`Inredningsbild för demensvänligt boende ${index + 1}`} className="w-full h-full object-cover" />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      {images.length > 1 && ( // Only show buttons if there's more than one image
        <>
          <CarouselPrevious className="ml-12 bg-white/80 hover:bg-white text-minnestig-purple disabled:text-gray-400 disabled:bg-white/50" /> {/* Custom styling for buttons */}
          <CarouselNext className="mr-12 bg-white/80 hover:bg-white text-minnestig-purple disabled:text-gray-400 disabled:bg-white/50" /> {/* Custom styling for buttons */}
        </>
      )}
    </Carousel>
  );
};

export default ArticleImageCarousel;
